const c = {
  "cdr-accordion-group": "cdr-accordion-group_15-5-1",
  "cdr-accordion": "cdr-accordion_15-5-1"
};
export {
  c as default
};
